<template>
  <div
    ref="container"
    class="w-full h-full"
  />
</template>

<script setup>
import { onMounted, onBeforeUnmount, ref, nextTick } from 'vue'
import { initScene, createParticles, updateParticles } from '@/composables/useParticlePhysics'
import { setupMouseTracking, getSwipeVector } from '@/composables/useMouseInteraction'
import * as THREE from 'three'

const container = ref(null)
let scene, camera, renderer, particleSystem, geometry, positions, velocities, cleanupMouse

onMounted(() => {
  requestAnimationFrame(() => {
    if (!container.value) {
      console.error("Container ref is not yet defined.")
      return
    }

  const { scene: s, camera: c, renderer: r } = initScene(container.value)
  scene = s
  camera = c
  renderer = r

  const particleData = createParticles()
  geometry = particleData.geometry
  positions = particleData.positions
  velocities = particleData.velocities

  particleSystem = new THREE.Points(geometry, new THREE.PointsMaterial({ color: 0xffddaa, size: 1.5 }))
  scene.add(particleSystem)

  cleanupMouse = setupMouseTracking(container.value, applyExplosionForce, {
    minSwipeDistance: 0.01,
    passMouseVec: false
    })

  animate()
})
})

onBeforeUnmount(() => {
  if (cleanupMouse) cleanupMouse()
  if (renderer) renderer.dispose()
})

function applyExplosionForce(direction) {
  const force = direction.length() * 100
  const norm = new THREE.Vector3(direction.x, direction.y, 0).normalize()
  for (let i = 0; i < velocities.length / 3; i++) {
    const i3 = i * 3
    velocities[i3 + 0] += norm.x * (Math.random() * force)
    velocities[i3 + 1] += norm.y * (Math.random() * force)
    velocities[i3 + 2] += (Math.random() - 0.5) * force
  }
}

function animate() {
  requestAnimationFrame(animate)
  updateParticles(positions, velocities)
  geometry.attributes.position.needsUpdate = true
  renderer.render(scene, camera)
}
</script>
